<template>
  <div
    ref="pageRef"
    class="w-full h-full"
  >
    <div class="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[800px]">
      <img
        src="../../assets/img/sbg.webp"
        class="w-full h-full object-cover z-0"
      />
      <div class="absolute bottom-4 sm:bottom-8 md:bottom-[49px] left-0 right-0 w-full h-full z-10 flex flex-col items-center justify-end px-4">
        <div class="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[96px] font-black text-center leading-none m-0">
          定制开发方案
        </div>
        <div class="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[72px] font-black text-center leading-none m-0">
          CUSTOM DEVELOPMENT SOLUTIONS
        </div>
        <div class="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-[36px] font-[w400] text-center leading-none m-0 z-20">
          LBE大空间
        </div>
        <div class="h-2 sm:h-3 md:h-4 lg:h-[17px] w-full max-w-[300px] sm:max-w-[500px] md:max-w-[800px] lg:max-w-[1199px] bg-[#0BE0BB] rounded-2xl -mt-2 sm:-mt-3 md:-mt-[12px]"></div>
      </div>
    </div>
    <div class="w-full bg-[#0C3D8E] flex flex-col items-center justify-center">
      <div
        class="scroll-fade-in"
        style="--delay: 0ms"
      >
        <img
          src="../../assets/img/busin.webp"
          alt="lbeTheme-bg"
          class="object-contain mt-6 sm:mt-8 md:mt-12 lg:mt-[68px] sm:w-auto px-4"
        />
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 md:gap-12 lg:gap-[128px] mt-4 sm:mt-6 md:mt-[23px] mb-6 sm:mb-8 md:mb-12 lg:mb-[86px] px-4 sm:px-6">
        <div
          class="scroll-fade-in-left"
          style="--delay: 120ms"
        >
          <img
            src="../../assets/img/yj_3.webp"
            alt="lbeTheme-bg"
            class="object-contain w-full sm:w-[280px] md:w-[320px] lg:w-[362px] h-auto sm:h-[350px] md:h-[400px] lg:h-[450px]"
          />
        </div>
        <div
          class="scroll-fade-in"
          style="--delay: 240ms"
        >
          <img
            src="../../assets/img/yj_1.webp"
            alt="lbeTheme-bg"
            class="object-contain w-full sm:w-[280px] md:w-[320px] lg:w-[362px] h-auto sm:h-[350px] md:h-[400px] lg:h-[450px]"
          />
        </div>
        <div
          class="scroll-fade-in-right"
          style="--delay: 360ms"
        >
          <img
            src="../../assets/img/yj_2.webp"
            alt="lbeTheme-bg"
            class="object-contain w-full sm:w-[280px] md:w-[320px] lg:w-[362px] h-auto sm:h-[350px] md:h-[400px] lg:h-[450px]"
          />
        </div>

      </div>
    </div>
    <div class="w-full bg-black">
      <div class="container mx-auto flex flex-col items-center justify-center">
        <img
          src="../../assets/img/kflc_3.webp"
          alt="lbeTheme-bg"
          class="object-contain mb-8 mt-6 sm:mt-8 md:mt-12 lg:mt-[68px] w-full scroll-fade-in sm:w-auto px-4 lg:mb-[98px]"
        />
        <div class="mb-6 sm:mb-8 md:mb-[12px] lg:mb-[46px] w-full px-4 sm:px-6">
          <div
            v-for="(item, index) in developItems"
            :key="item.id"
            class="flex flex-col md:flex-row items-center md:items-end justify-center"
          >
            <!-- 左侧箭头（仅桌面端显示） -->
            <div
              v-if="index % 2 === 0"
              class="hidden md:block"
            >
              <img
                src="../../assets/img/kflc_2.svg"
                alt="lbeTheme-bg"
                class="object-contain w-[120px] md:w-[150px] lg:w-[207px] h-[120px] md:h-[150px] lg:h-[207px] md:ml-[80px] lg:ml-[165px]"
                v-if="index !== developItems.length - 1"
              />
              <div
                v-else
                class="w-[120px] md:w-[150px] lg:w-[207px] h-[120px] md:h-[150px] lg:h-[207px] md:ml-[80px] lg:ml-[165px]"
              ></div>
            </div>

            <!-- 卡片内容 -->
            <div
              v-if="index % 2 === 0"
              class="flex flex-col md:flex-row items-center justify-center border-2 border-white rounded-2xl md:rounded-[68px] px-4 sm:px-6 md:px-10 py-6 sm:py-8 bg-[#1D3C7D] w-full md:w-[67%] md:mb-[64px] mb-4"
            >
              <div class="flex flex-col items-center justify-center mb-4 md:mb-0">
                <div class="text-white text-lg sm:text-xl md:text-[24px] font-bold mb-2 sm:mb-3 md:mb-[16px] text-center">
                  {{ item.title }}
                </div>
                <div class="text-white text-sm sm:text-base md:text-[16px] leading-relaxed font-[w400] text-center">
                  {{ item.description }}
                </div>
              </div>
              <div class="hidden md:block w-[4px] h-[148px] bg-white mx-6 md:mx-10"></div>
              <img
                :src="item.image"
                alt="lbeTheme-bg"
                class="object-contain w-[100px] h-[100px] sm:w-[120px] sm:h-[120px] md:w-[140px] md:h-[140px] mt-4 md:mt-0"
              />
            </div>

            <div
              v-if="index % 2 === 1"
              class="flex flex-col md:flex-row items-center justify-center border-2 border-white rounded-2xl md:rounded-[68px] px-4 sm:px-6 md:px-10 py-6 sm:py-8 bg-[#1D3C7D] w-full md:w-[67%] md:mb-[100px] mb-4"
            >
              <img
                :src="item.image"
                alt="lbeTheme-bg"
                class="object-contain w-[100px] h-[100px] sm:w-[120px] sm:h-[120px] md:w-[140px] md:h-[140px] mb-4 md:mb-0"
              />
              <div class="hidden md:block w-[4px] h-[148px] bg-white mx-6 md:mx-10"></div>
              <div class="flex flex-col items-center justify-center mt-4 md:mt-0">
                <div class="text-white text-lg sm:text-xl md:text-[24px] font-bold mb-2 sm:mb-3 md:mb-[16px] text-center">
                  {{ item.title }}
                </div>
                <div class="text-white text-sm sm:text-base md:text-[16px] leading-relaxed font-[w400] text-center">
                  {{ item.description }}
                </div>
              </div>
            </div>

            <!-- 右侧箭头（仅桌面端显示） -->
            <div
              v-if="index % 2 === 1"
              class="hidden md:block"
            >
              <img
                src="../../assets/img/kflc_1.svg"
                alt="lbeTheme-bg"
                class="object-contain w-[120px] md:w-[150px] lg:w-[207px] h-[120px] md:h-[150px] lg:h-[207px] md:mr-[80px] lg:mr-[165px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full h-auto relative scroll-fade-in">
      <img
        src="../../assets/img/kfys_bg.webp"
        alt="lbeTheme-bg"
        class="object-contain w-full h-auto md:h-full hidden md:block"
      />
      <div class="absolute top-4 sm:top-6 md:top-8 lg:top-[68px] left-0 right-0 mx-auto flex flex-col items-center justify-center px-4">
        <img
          src="../../assets/img/kfys_icon.webp"
          alt="lbeTheme-bg"
          class="object-contain max-w-full h-auto scroll-fade-in"
        />
        <div class="text-white text-sm sm:text-base md:text-lg lg:text-[24px] font-[w400] mt-4 sm:mt-6 md:mt-[31px] mb-4 sm:mb-6 md:mb-[55px] text-center">大空间制作技术沉淀深厚，经验粲然可观</div>
      </div>

      <!-- 移动端：垂直列表展示技术卡片 -->
      <div
        class="md:hidden pt-6 pb-8 px-4 scroll-fade-in"
        :style="{
          backgroundImage: `url(${kfysBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }"
      >
        <img
          src="../../assets/img/kfys_icon.webp"
          alt="lbeTheme-bg"
          class="object-contain max-w-full h-auto scroll-fade-in pb-8"
        />
        <div class="flex flex-col gap-4">
          <div class="tech-title-card-mobile">
            亚毫米级精度的激光定位技术
          </div>
          <div class="tech-title-card-mobile">
            "五感"全沉浸式VR设备
          </div>
          <div class="tech-title-card-mobile">
            实时渲染技术
          </div>
          <div class="tech-title-card-mobile">
            多感调度技术
          </div>
          <div class="tech-title-card-mobile">
            模块化的顶层设计技术
          </div>
          <div class="tech-title-card-mobile">
            业内顶尖全身动捕精确定位技术
          </div>
          <div class="tech-title-card-mobile">
            超强任意形状空间、任意尺寸空间、任意数量定位目标接入等系统能力
          </div>
        </div>
      </div>
      <!-- 技术标题卡片 -->
      <div class="hidden md:block absolute left-[469px] top-[307px] flex items-center justify-center  lg:w-[400px]">
        <div class="tech-title-card">
          亚毫米级精度的激光定位技术
        </div>
      </div>
      <div class="hidden md:block absolute top-[342px] right-[362px] flex items-center justify-center  lg:w-[400px]">
        <div class="tech-title-card">
          “五感”全沉浸式VR设备
        </div>
      </div>
      <div class="hidden md:block absolute top-[470px] left-[386px] flex items-center justify-center  lg:w-[400px]">
        <div class="tech-title-card">
          实时渲染技术
        </div>
      </div>
      <div class="hidden md:block absolute top-[523px] right-[585px] flex items-center justify-center  lg:w-[400px]">
        <div class="tech-title-card">
          多感调度技术
        </div>
      </div>
      <div class="hidden md:block absolute top-[687px] left-[632px] flex items-center justify-center lg:w-[400px]">
        <div class="tech-title-card">
          模块化的顶层设计技术
        </div>
      </div>
      <div class="hidden md:block absolute top-[738px] right-[304px] flex items-center justify-center  lg:w-[400px]">
        <div class="tech-title-card">
          业内顶尖全身动捕精确定位技术
        </div>
      </div>
      <div class="hidden md:block absolute top-[868px] left-[329px] flex items-center justify-center lg:w-[812x]">
        <div class="tech-title-cardsp">
          超强任意形状空间、任意尺寸空间、任意数量定位目标接入等系统能力
        </div>
      </div>
    </div>

    <div class=" w-full h-auto  bg-[#04193B] lg:pb-[79px] pb-6 lg:pt-[56px]  pt-6">

      <img
        src="../../assets/img/hezuo.webp"
        alt="service-banner"
        class=" mx-auto scroll-fade-in mb-6 lg:mb-[46px]"
      />
      <!-- 表单 -->
      <div class="w-full mx-auto px-4 sm:px-6 md:px-8">
        <div class="w-full max-w-[1400px] mx-auto">
          <CooperationForm />
        </div>
      </div>
    </div>

  </div>
</template>
<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import CooperationForm from "@/components/CooperationForm.vue";
import kflc_4 from "../../assets/img/kflc_4.webp";
import kflc_5 from "../../assets/img/kflc_5.webp";
import kflc_6 from "../../assets/img/kflc_6.webp";
import kflc_7 from "../../assets/img/kflc_7.webp";
import kflc_8 from "../../assets/img/kflc_8.webp";
import kfysBg from "../../assets/img/kfys_bg.webp";

const pageRef = ref<HTMLElement | null>(null);
let scrollFadeObserver: IntersectionObserver | null = null;

onMounted(() => {
  setupScrollFadeObserver();
});

onBeforeUnmount(() => {
  scrollFadeObserver?.disconnect();
  scrollFadeObserver = null;
});

const setupScrollFadeObserver = async () => {
  await nextTick();
  const root = pageRef.value;
  if (!root) return;

  const elements = Array.from(
    root.querySelectorAll<HTMLElement>(
      ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
    )
  );
  if (elements.length === 0) return;

  if (!("IntersectionObserver" in window)) {
    elements.forEach((el) => el.classList.add("fade-in-visible"));
    return;
  }

  scrollFadeObserver?.disconnect();
  scrollFadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        (entry.target as HTMLElement).classList.add("fade-in-visible");
        scrollFadeObserver?.unobserve(entry.target);
      });
    },
    {
      root: null,
      threshold: 0.15,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  elements.forEach((el) => scrollFadeObserver?.observe(el));
};

// Consult page
const developItems = ref([
  {
    id: 1,
    title: "创意策划",
    description:
      "深度对接客户核心需求与商业场景，量身定制专属虚拟空间框架、互动逻辑与体验路径，拆解行业痛点并融入差异化创意，打造兼具科技沉浸感与商业适配性的定制化方案蓝图，确保项目精准匹配目标人群与运营目标。",
    image: kflc_4,
  },
  {
    id: 2,
    title: "美术制作",
    description:
      "以客户定制主题为核心，融合科技感蓝紫主调、荧光线条等视觉元素，量身打造高还原度虚拟场景、专属 UI 设计与动态光影特效，细化材质纹理与互动反馈视觉呈现，构建符合项目调性的专属科技美学体系，强化用户沉浸代入感。",
    image: kflc_8,
  },
  {
    id: 3,
    title: "程序开发",
    description:
      "基于定制化创意方案搭建专属技术架构，按需开发个性化交互逻辑、多设备（VR/XR）适配模块与实时同步功能，集成定制化数据统计、播控管理等运营工具，攻克专属场景技术难点，筑牢系统稳定性与流畅性，确保技术落地与定制需求无缝契合。",
    image: kflc_7,
  },
  {
    id: 4,
    title: "运营支撑",
    description:
      "提供定制化全周期运营赋能，涵盖专属设备调试指导、运营团队专项培训、定制化数据面板使用教学，实时响应运营场景中的个性化问题，输出针对性优化建议，搭配灵活的定制内容更新支持，助力合作方快速上手、高效运维定制项目。",
    image: kflc_6,
  },
  {
    id: 5,
    title: "产品发行",
    description:
      "完成定制产品合规审核与多场景适配测试，提供专属上线部署方案，配套定制化市场推广素材与落地指导，助力产品快速切入目标市场，实现 “定制开发 - 落地运营 - 商业盈利” 的高效闭环，加速定制化项目的商业价值兑现。",
    image: kflc_5,
  },
]);
</script>

<style scoped>
/* 滚动飞入（scroll-fade-in）需要 JS 追加 fade-in-visible 才会触发 */
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  transition-delay: var(--delay, 0ms);
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  transition-delay: var(--delay, 0ms);
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  transition-delay: var(--delay, 0ms);
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

.tech-title-card {
  background: linear-gradient(180deg, #5fd3ff 0%, #b248ff 100%);
  border-radius: 16px;
  padding: 12px 24px;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: bold;
  font-family: "Noto Sans SC", sans-serif;
  white-space: nowrap;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.tech-title-cardsp {
  background: linear-gradient(180deg, #5fd3ff 0%, #b248ff 100%);
  border-radius: 16px;
  padding: 12px 24px;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: bold;
  font-family: "Noto Sans SC", sans-serif;
  white-space: nowrap;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}
@media (min-width: 768px) {
  .tech-title-card {
    border-radius: 24px;
    padding: 18px 36px;
    font-size: 22px;
  }
  .tech-title-cardsp {
    padding: 12px 24px;
  }
}

@media (min-width: 1024px) {
  .tech-title-card {
    border-radius: 32px;
    padding: 35px 0px;
    font-size: 24px;
    font-weight: blod;
  }
  .tech-title-cardsp {
    padding: 35px 34px;
  }
}

.tech-title-card-mobile {
  background: linear-gradient(180deg, #5fd3ff 0%, #b248ff 100%);
  border-radius: 16px;
  padding: 16px 20px;
  text-align: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  font-family: "Noto Sans SC", sans-serif;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  white-space: normal;
  word-break: break-word;
}

@media (min-width: 640px) {
  .tech-title-card-mobile {
    font-size: 16px;
    padding: 18px 24px;
  }
}
</style>